// extracted by mini-css-extract-plugin
export default {"premises":"premises_premises__Fq2cT"};